import { NextRequest, NextResponse } from 'next/server'
import { createTransport } from 'nodemailer'
import { db } from '@/db'
import { waitlist } from '@/db/schema'
import { eq } from 'drizzle-orm'

const ADMIN_EMAIL = 'james@quality-intelligence.co'

function notifyAdmin(email: string) {
  if (!process.env.EMAIL_SERVER_HOST) return
  const transport = createTransport({
    host: process.env.EMAIL_SERVER_HOST,
    port: Number(process.env.EMAIL_SERVER_PORT ?? 587),
    auth: process.env.EMAIL_SERVER_USER
      ? { user: process.env.EMAIL_SERVER_USER, pass: process.env.EMAIL_SERVER_PASSWORD }
      : undefined,
  })
  transport
    .sendMail({
      from: process.env.EMAIL_FROM ?? ADMIN_EMAIL,
      to: ADMIN_EMAIL,
      subject: `New waitlist signup — ${email}`,
      text: `${email} tried to sign in to AskQIEN and was added to the waitlist.`,
    })
    .catch(() => {})
}

export async function POST(req: NextRequest) {
  const body = await req.json().catch(() => null)
  const email = typeof body?.email === 'string' ? body.email.toLowerCase().trim() : ''

  if (!email) {
    return NextResponse.json({ error: 'email is required' }, { status: 400 })
  }

  // Idempotent — silently succeed if already on the waitlist
  const [existing] = await db
    .select({ id: waitlist.id })
    .from(waitlist)
    .where(eq(waitlist.email, email))
    .limit(1)

  if (!existing) {
    await db.insert(waitlist).values({ email })
    notifyAdmin(email)
  }

  return NextResponse.json({ ok: true })
}
